/**
 * @author Kelnik
 *
 * CallBack - Форма для отправка обратного звонка
 */

import axios from 'axios';
import Select from 'components/forms/select';
import Utils from 'common/scripts/utils';
import Validation from 'components/forms/validation_global';

class CallBack {
    constructor(options) {
        this.container = options.container ? options.container.querySelector('.j-callback-popup') : false;
        this.target = options.target;

        this.formSelector = '.j-callback-popup-form';
        this.resultSelector = '.j-callback-popup-result';
        this.successSelector = '.j-callback-popup-success';
        this.errorSelector = '.j-callback-popup-error';
        this.inputSelector = '.j-callback-popup-input';

        this.timeSelectSelector = '.j-callback__time';
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._initSelect();
        this._initValidation();
        this._replaceText();
        this._bindEvents();
    }

    _initElements() {
        this.form = this.container.querySelector(this.formSelector);
        this.result = this.container.querySelector(this.resultSelector);
        this.success = this.container.querySelector(this.successSelector);
        this.error = this.container.querySelector(this.errorSelector);
        this.inputs = Array.from(this.container.querySelectorAll(this.inputSelector));
        this.timeSelect = this.container.querySelector(this.timeSelectSelector);
    }

    _initSelect() {
        if (this.timeSelect) {
            new Select({
                element      : this.timeSelect,
                disableSearch: true
            }).init();
        }
    }

    _initValidation() {
        const validation = new Validation(); // eslint-disable-line

        if (this.form.hasAttribute('data-init')) {
            validation.refresh(this.container);
        }
    }

    _replaceText() {
        if (this.target.dataset.replaceText) {
            const texts = Array.from(this.container.querySelectorAll('.j-callback-popup-text'));

            texts.forEach((text) => {
                text.innerHTML = this.target.dataset.replaceText;
            });
        }
    }

    _bindEvents() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();

            if (this.form.hasAttribute('validity')) {
                this._send();
            }
        });
    }

    _setDataLayerEvent() {
        if (!window.dataLayer) {
            return;
        }
        window.dataLayer.push({'event': 'zakazat zvonok'}); // eslint-disable-line
    }

    _send() {
        const $messageBot = $(this.form).find('[name="message_bot"]');

        if ($messageBot.length) {
            $messageBot.val('I_am_a_real_man');
        }

        const action = this.form.action;
        const method = this.form.method;
        const sendData = new FormData(this.form);

        this._addAdditionalDataFromTarget(sendData);
        this._addAdditionalDataFromForm(sendData);

        axios[method](action, sendData)
            .then((response) => {
                const status = Boolean(response.data.request.status);

                this._displayResult();

                if (status) {
                    this._setDataLayerEvent();
                    this._toSuccessSend();
                } else {
                    this._toErrorSend();
                }
            })
            .catch((error) => { // eslint-disable-line
                console.error(error); // eslint-disable-line
            });
    }

    _addAdditionalDataFromTarget(formData) {
        if (!this.target.dataset) {
            return;
        }

        for (const key in this.target.dataset) {
            if (Object.prototype.hasOwnProperty.call(this.target.dataset, key) && key !== 'href' && key !== 'formId') {
                formData.append(key, this.target.dataset[key]);
            }
        }
    }

    _addAdditionalDataFromForm(formData) {
        if (!this.target.dataset.formId) {
            return;
        }

        const form = document.getElementById(this.target.dataset.formId);
        const dataFromForm = new FormData(form);

        for (const data of dataFromForm) {
            formData.append(data[0], data[1]);
        }
    }

    _displayResult() {
        Utils.show(this.result, 'flex');
    }

    _toSuccessSend() {
        Utils.show(this.success);
    }

    _toErrorSend() {
        Utils.show(this.error);
    }
}

export default CallBack;
